import type { StandardData } from '../../../index';

export interface ItemConfig {
  image?: string;
  badgeText?: string;
  insideText?: string;
}

// eslint-disable-next-line no-shadow
export enum GraphicType {
  rect = 'rect',
  circle = 'circle',
  text = 'text',
  group = 'group',
  image = 'image',
  polygon = 'polygon',
  line = 'line',
  path = 'path',
  bezierCurve = 'bezierCurve',
  ellipse = 'ellipse',
  arc = 'arc',
  sector = 'sector'
}

export interface Graphic {
  id?: string;
  x?: number;
  y?: number;
  type: GraphicType;
  shape?: any;
  style?: any;
  emphasis?: any;
  rotation?: number;
  originX?: number;
  originY?: number;
  scaleX?: number;
  scaleY?: number;
  transition?: string | string[];
  textContent?: any;
  textConfig?: any;
  children?: Graphic[];
  // echarts or custom prototype maybe used by specific graphic
  [propName: string]: any;
}

export interface DvScatterData extends StandardData {
  itemConfig?: ItemConfig;
  // format value when has log axis
  formatValue?: unknown;
  nextValue?: unknown[];
  formatNextValue?: unknown[];
  preValue?: unknown[];
  formatPreValue?: unknown;
}
